import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
// import { MaterialModule } from './material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MultiRoleSelectorComponent } from '../shared/components/multi-role-selector/multi-role-selector.component';

import { CheckboxDialogModule, ConfirmationDialogModule, CountdownDialogModule, DenyDialogModule, InputDialogModule, ListSelectionDialogModule, LoginBoxDialogModule, MessageBoxDialogModule, TextNoteDialogModule, UserSearchDialogModule, ReturnNoteDialogModule, SplashDialogModule, NotificationsDialogModule, ParentGuardianDialogModule } from './dialogs';
import { AgePipeModule, ContractApprovalPipeModule, DenialTypesPipeModule, FormStatusPipeModule, PendingApprovalPipeModule, PhonePipeModule, ProgramPipeModule, ProxyTypePipeModule, RoleFilterPipeModule, SafeHTMLPipeModule, SchoolYearPipeModule, SelectCountPipeModule, SelectedChallengesPipeModule, SocialSecurityPipeModule, YesNoPipeModule, ZipcodePipeModule } from './pipes';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';


const Pipes = [
    AgePipeModule,
    ContractApprovalPipeModule,
    DenialTypesPipeModule,
    FormStatusPipeModule,
    PendingApprovalPipeModule,
    PhonePipeModule,
    ProgramPipeModule,
    ProxyTypePipeModule,
    RoleFilterPipeModule,
    SafeHTMLPipeModule,
    SchoolYearPipeModule,
    SelectCountPipeModule,
    SelectedChallengesPipeModule,
    SocialSecurityPipeModule,
    YesNoPipeModule,
    ZipcodePipeModule,
];

const Dialogs = [
    CheckboxDialogModule,
    ConfirmationDialogModule,
    CountdownDialogModule,
    DenyDialogModule,
    InputDialogModule,
    ListSelectionDialogModule,
    LoginBoxDialogModule,
    MessageBoxDialogModule,
    NotificationsDialogModule,
    ParentGuardianDialogModule,
    ReturnNoteDialogModule,
    SplashDialogModule,
    TextNoteDialogModule,
    UserSearchDialogModule,
];


@NgModule({
    declarations: [
        MultiRoleSelectorComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        // MaterialModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,

        // Custom Pipes and Dialogs
        ...Pipes,
        ...Dialogs,
    ],
    exports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        // MaterialModule,
        ReactiveFormsModule,
        ...Pipes,
        MultiRoleSelectorComponent,
    ],
    providers: [
        TitleCasePipe,
        DatePipe,
    ],
})
export class SharedModule { }
